import React, {useEffect} from 'react';
import styles from './index.module.scss'
import {Button, Badge, notification} from 'antd';
import {
    GitlabOutlined
} from '@ant-design/icons';
import Footer from '../../components/footer'
import chartsImage from '../../static/image/charts.gif'
import componentImage from '../../static/image/components.svg'
import adapter from '../../static/image/adapter.svg'
import join from '../../static/image/join.svg'

const Home = () => {
    useEffect(() => {
        document.title = '首页';
    }, []);
    return (
        <div className={styles.index}>
            <div className={styles.exhibition}>
                <div className={styles.pointsInit}>
                    <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
                </div>
                <div className={styles.info}>
                    <h1 className={styles.name}><a target="_blank" href="http://meichuangit.net.cn/">原生鸿蒙</a>图表组件库 - <b>McCharts</b></h1>
                    <div className={styles.tips}>提供开箱即用的一系列图表组件，提高你的开发效率！！！</div>
                    <div className={styles.btns}>
                        <Button type="primary" size='large'>
                            <a href="/GettingStarted" target="_blank" rel="noopener noreferrer">
                                开始使用
                            </a>
                        </Button>
                        <Badge count={'70+'} color="#000">
                            <Button icon={<GitlabOutlined/>} size='large'>
                                <a href="https://gitee.com/cyaofeng_admin/mc-charts" target="_blank" rel="noopener noreferrer">
                                    加入共创
                                </a>
                            </Button>
                        </Badge>
                    </div>
                </div>
                <div className={styles.image}>
                    <img src={chartsImage}/>
                </div>
            </div>
            <div className={styles.components}>
                <div className={styles.image}>
                    <img className={styles.componentIcon} src={componentImage}/>
                </div>
                <div className={styles.info}>
                    <h1 className={styles.name}>可重复使用的组件且易于使用</h1>
                    <div className={styles.tips}>借助McCharts，您只需要几行代码即可使用任何组件,<br/>并且可以进行出色的自定义，最重要是非常易于使用和理解</div>
                    <div className={styles.btns}>
                        <Button type="primary" size='large'>
                            <a href="/Introduction" target="_blank" rel="noopener noreferrer">
                                组件文档
                            </a>
                        </Button>
                    </div>
                </div>
            </div>
            <div className={styles.adapter}>
                <div className={styles.info}>
                    <h1 className={styles.name}>组件自由跨端，响应式适配</h1>
                    <div className={styles.tips}>借助HarmonyOS ArkTS的跨端能力，<br/>McCharts也可以无条件适配各个设备端，做到一套代码适配多端</div>
                    <div className={styles.btns}>
                        <Button type="primary" size='large'>
                            <a href="https://www.harmonyos.com/" target="_blank" rel="noopener noreferrer">
                                多端适配
                            </a>
                        </Button>
                    </div>
                </div>
                <div className={styles.image}>
                    <img className={styles.componentIcon} src={adapter}/>
                </div>
            </div>
            <div className={styles.components}>
                <div className={styles.image}>
                    <img className={styles.componentIcon} src={join}/>
                </div>
                <div className={styles.info}>
                    <h1 className={styles.name}>加入我们？</h1>
                    <div className={styles.tips}>是否您拥有更多的想法？或者某些项目的特殊业务场景？可以加入我们的共创，<br></br>让McCharts变得更加灵活、业务场景适配性更高</div>
                    <div className={styles.btns}>
                        <Button type="primary" size='large'>
                            <a href="https://gitee.com/cyaofeng_admin/mc-charts" target="_blank" rel="noopener noreferrer">
                                感谢您的加入
                            </a>
                        </Button>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    )
}

export default Home
